export namespace ProductPropertiesActions {
    export class SetAllProductProperties {
      static readonly type = '[ProductProperties] SetAllProductProperties';
      constructor() {}
    }
  }
  